import { useMemo } from 'react'
import { object, bool } from 'prop-types'
import { matchPath, useLocation } from 'react-router-dom'
import { ICONE } from 'icons'
import { BaseAccordion, BaseHeaderConIcona } from 'layout'
import { BaseListaCoppieChiaveValore } from 'text'
import { formattaCognomeNome } from 'utils'
import { useRoutes } from '../../navigation/RoutesProvider'
import { useContextGenerico } from '../../util/ContextGenericoProvider'

Agente.propTypes = {
  agente: object.isRequired,
  visioneRiassuntiva: bool,
  propsHeader: object
}

export default function Agente(props) {
  const {
    agente,
    visioneRiassuntiva,
    propsHeader,
    ...restProps
  } = props

  const chiaviRottePadre = useContextGenerico?.()?.chiaviRottePadre_usaQualificaAgente
  const getPath = useRoutes?.()?.getPath
  const urlCorrente = useLocation?.()?.pathname

  const usaQualifica = useMemo(() => {
    if (chiaviRottePadre && getPath && urlCorrente) {
      return chiaviRottePadre.some(chiave => {
        const pathRottaPadre = getPath(chiave)
        if (!pathRottaPadre) return false
        const match = matchPath(urlCorrente, { path: pathRottaPadre })
        // Se match = null, l'urlCorrente non è una sottorotta di pathRottaPadre
        return Boolean(match)
      })
    }
    return false
  }, [chiaviRottePadre, urlCorrente])

  if (!agente) return null

  const {
    grado,
    gradoDescr,
    matricola,
    qualifica
  } = agente

  const cognomeNome = formattaCognomeNome(agente)
  const titolo = matricola ? `${cognomeNome} (${matricola})` : cognomeNome
  const gradoFormattato = usaQualifica
    ? qualifica || gradoDescr || grado
    : gradoDescr || grado

  const header = (
    <BaseHeaderConIcona
      icona={<ICONE.PERSONA />}
      titolo={titolo}
      sottotitolo={gradoFormattato}
      {...propsHeader}
    />
  )

  if (visioneRiassuntiva) return header

  return (
    <BaseAccordion
      contenutoNonEspanso={header}
      contenutoEspanso={
        <BaseListaCoppieChiaveValore
          titolo='Dati agente'
          coppie={{
            'Cognome e nome': cognomeNome,
            'Grado': gradoFormattato,
            'Matricola': matricola
          }}
        />
      }
      {...restProps}
    />
  )
}